import React, { useEffect, useState } from "react";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { Input, Message, Switch, Button } from "../../../BP2Components";

import "./TableWidgetSettings.less";

const TableWidgetSettings = ({ value, data, setWidgetSettings }) => {
   const dispatch = useDispatch();
   const intl = useIntl();

   const [settings, setSettings] = useState({
      edit: false,
      ...value,
   });

   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };

   useEffect(() => {
      setSettings({
         ...value,
      });
   }, [value]);

   const handleSave = () => {
      Message.success(intl.formatMessage({ id: "global.saved" }));
      dispatch(setWidgetInSheetParams(settings));
      setWidgetSettings(settings);
   };

   const handleChange = (e, serieKey) => {
      const optionName = e?.target?.name;
      const optionValue = e?.target?.value;
      const newSeries = settings.tableSeries.map((serie) =>
         serie.seriesKey === serieKey ? { ...serie, [optionName]: optionValue } : serie,
      );
      setSettings({ ...settings, tableSeries: newSeries });
   };

   const handleDefaultFilterChange = (serieDataId) => (nextValueOrEvent) => {
      const defaultFilterId =
         typeof nextValueOrEvent === "string" ? nextValueOrEvent : nextValueOrEvent?.target?.value;

      const nextSeries = (settings?.tableSeries ?? []).map((serie) => {
         if (String(serie.dataId) === String(serieDataId)) {
            return {
               ...serie,
               defaultFilterId,
            };
         }
         return serie;
      });

      const nextSettings = {
         ...settings,
         tableSeries: nextSeries,
      };

      setSettings(nextSettings);
   };

   const handleEditListBuilder = (dataId) => {
      if (dataId) {
         window.open(`/listbuilder?listId=${dataId}`, "_blank");
      } else {
         Message.warning(
            intl.formatMessage(
               { id: "global.pleaseEnterListId" },
               { defaultMessage: "Proszę wpisać List ID" },
            ),
         );
      }
   };

   const handleChangeInput = (name) => (value) => {
      setSettings({ ...settings, [name]: value });
   };

   return (
      <>
         <div className="widget-button gx-pl-4">
            <div key="btnSet" className="gx-pl-4">
               {(settings.tableSeries ?? []).map((serie) => (
                  <div
                     key={serie.dataId}
                     className="serie-settings"
                     style={{ display: "flex", alignItems: "flex-end" }}
                  >
                     <div className="serie-option">
                        <div>
                           <IntlMessages id="settings.listId" />
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                           <Input
                              type="text"
                              className="dataId"
                              name="dataId"
                              defaultValue={serie.dataId}
                              onChange={(e) => handleChange(e, serie.seriesKey)}
                              style={{ width: "250px" }}
                           />
                           <Button
                              onClick={() => handleEditListBuilder(serie.dataId)}
                              style={{ whiteSpace: "nowrap" }}
                           >
                              <IntlMessages id="global.edit" />
                           </Button>
                        </div>
                     </div>
                     <div className="serie-option gx-pl-3 gx-pb-2">
                        <div>
                           <IntlMessages id="global.itemsPerPage" />
                        </div>
                        <Input
                           type="number"
                           className="itemsPerPage"
                           name="itemsPerPage"
                           defaultValue={serie.itemsPerPage}
                           onChange={(e) => handleChange(e, serie.seriesKey)}
                           style={{ width: "100px" }}
                        />
                     </div>

                     <div className="serie-option gx-pl-3 gx-pb-2">
                        <div>
                           <IntlMessages id="global.defaultFilterId" />
                        </div>
                        <Input
                           className="defaultFilterId"
                           name="defaultFilterId"
                           value={serie.defaultFilterId ?? ""}
                           onChange={handleDefaultFilterChange(serie.dataId)}
                           style={{ width: "250px" }}
                        />
                     </div>
                  </div>
               ))}
               <div className="table-settings-option-container">
                  <div className="table-option-label">
                     <IntlMessages id="global.showFilters" />
                  </div>
                  <div>
                     <Switch
                        defaultChecked={
                           typeof value?.showListFilters === "boolean"
                              ? value?.showListFilters
                              : false
                        }
                        onChange={(e) => handleSwitch(e, "showListFilters")}
                     />
                  </div>
                  <div className="table-option-label">Possible edit</div>
                  <div>
                     <Switch
                        defaultChecked={typeof value?.edit === "boolean" ? value?.edit : false}
                        onChange={(e) => handleSwitch(e, "edit")}
                     />
                  </div>
               </div>
            </div>

            <Button
               key="btn"
               buttonType="primary"
               size="medium"
               htmlType="submit"
               onClick={handleSave}
               className="gx-ml-4"
            >
               <IntlMessages id="global.preview" />
            </Button>
         </div>
      </>
   );
};

export default TableWidgetSettings;
